export const LANGUAGE_LOCAL_STORAGE_KEY = "locale";
export const DEFAULT_LANGUAGE = "en-US";
